import React, { useEffect, useRef } from "react";
import {
  HeadingStickyContainer,
  LandingContainer,
  Headline,
  Paragraph,
  HeadingWrapper,
  TilesContainer,
  Row,
  Column,
  FixedWrapper,
} from "../styles/components/landing";
import { TileWrapper } from "../styles/components/tiles";
import TileComponent from "./tiles";
import Navigation from "./navigation";
import animations from "../animations/animations";
import { NavigationContainer } from "../styles/components/navigation";

const Layout = props => {
  const { title, colors, section } = props;

  const landingRef = useRef(null);
  const headingRef = useRef(null);
  const subheadingRef = useRef(null);
  const paragraphRef = useRef(null);
  const navigationRefs = useRef(null);

  const componentContent = Object.values(props)
    .filter(component => component.moduleTitle !== "component--colour")
    .map(component => ({
      key: component.key ? component.key : component.moduleTitle,
      type: component.__typename ? component.__typename : component.key,
      content: component.content ? component.content : component.text,
    }));

  useEffect(() => {
    if (
      !navigationRefs.current ||
      !headingRef.current ||
      !subheadingRef.current ||
      !paragraphRef.current
    )
      return;

    const tl = animations.timeline({
      scrollTrigger: {
        trigger: landingRef.current,
        id: title,
        start: () => {
          if (section === "introduction") {
            return "top top";
          } else {
            return "+=1000";
          }
        },
        end: "bottom bottom",
      },
    });

    tl.fromTo(
      navigationRefs.current.leftNavigationRef,
      { yPercent: 200 },
      { yPercent: -200, duration: 0.75, ease: "power4.out" }
    )
      .fromTo(
        navigationRefs.current.rightNavigationRef,
        { yPercent: -300 },
        { yPercent: 0, duration: 0.75, ease: "power4.out" },
        0
      )
      .fromTo(
        headingRef.current,
        {
          yPercent: 100,
          opacity: 0,
        },
        {
          yPercent: 0,
          opacity: 1,
          duration: 1,
          ease: "power4.out",
        }
      )
      .fromTo(
        subheadingRef.current,
        {
          yPercent: 100,
          opacity: 0,
        },
        {
          yPercent: 0,
          opacity: 1,
          duration: 1,
          ease: "power4.out",
        },
        ">-0.5"
      )
      .fromTo(
        paragraphRef.current.children,
        {
          yPercent: 100,
          opacity: 0,
        },
        {
          yPercent: 0,
          opacity: 1,
          stagger: 0.25,
          duration: 1,
          ease: "power4.out",
        },
        ">-0.5"
      );
  }, []);

  return (
    <>
      <LandingContainer ref={landingRef} id={title}>
        <HeadingStickyContainer>
          <HeadingWrapper>
            <FixedWrapper>
              <NavigationContainer>
                <Navigation ref={navigationRefs} section={section} />
              </NavigationContainer>
              {componentContent.map((component, index) => {
                switch (component.key) {
                  case "component--heading":
                    return (
                      <Headline
                        ref={headingRef}
                        key={`${component.key}-${index}`}
                        $color={colors}
                        $padding
                        dangerouslySetInnerHTML={{ __html: component.content }}
                      />
                    );
                  case "component--subheading":
                    return (
                      <Headline
                        ref={subheadingRef}
                        key={`${component.key}-${index}`}
                        $color={colors}
                        dangerouslySetInnerHTML={{ __html: component.content }}
                      />
                    );
                  default:
                    return null;
                }
              })}
            </FixedWrapper>
            <Row ref={paragraphRef} $padding $justify="flex-start">
              {componentContent
                .filter(component => component.key === "component--paragraph")
                .map((component, index) => (
                  <Column key={`${component.key}-${index}`} $padding>
                    <Paragraph
                      $color={colors}
                      dangerouslySetInnerHTML={{ __html: component.content }}
                    />
                  </Column>
                ))}
            </Row>
          </HeadingWrapper>
        </HeadingStickyContainer>
        <TileWrapper $maxPadding={section !== "introduction"}>
          <TilesContainer $margin={section !== "introduction"}>
            {componentContent
              .filter(component => component.key === "component--tiles")
              .map(component => (
                <TileComponent
                  key={component.key}
                  section={section}
                  content={component.content}
                />
              ))}
          </TilesContainer>
        </TileWrapper>
      </LandingContainer>
    </>
  );
};

export default Layout;
